module.exports = __webpack_public_path__ + "static/media/Stock 5.0df5ca30.svg";